import { render, staticRenderFns } from "./prizeInfoCard.vue?vue&type=template&id=0496e261&scoped=true"
import script from "./prizeInfoCard.vue?vue&type=script&lang=js"
export * from "./prizeInfoCard.vue?vue&type=script&lang=js"
import style0 from "./prizeInfoCard.vue?vue&type=style&index=0&id=0496e261&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496e261",
  null
  
)

export default component.exports